let VersionService = function ($http, $rootScope) {
  let VERSION_CHECK_INTERVAL_IN_MS = 5 * 60 * 1000; // 5 minutes
  let VERSION_CHECK_WITH_SERVER_AFTER = 3 * 60 * 60 * 1000; // 3 hours
  let versionUrl = WEBSERVICEURL + "/dataagility/api/service.version";

  function ensureVersionMatchWithServerLoop() {
    // Check localstorage
    if (shouldCheckForNewVersion()) {
      let lastVersion = localStorage.getItem("lastVersion");

      getVersionFromServer().then((res) => {
        localStorage.setItem("lastVersionCheckedAt", Date.now() + "");
        localStorage.setItem("lastVersion", res.version);

        if (lastVersion != null && res.version != lastVersion) {
          localStorage.setItem("lastVersionReload", Date.now() + "");
          window.location.reload();
        }
      });
    }

    setTimeout(
      () => {
        ensureVersionMatchWithServerLoop()
      },
      VERSION_CHECK_INTERVAL_IN_MS
    );
  }

  function getVersionFromServer() {
    return $http.get(versionUrl).then((res) => res.data);
  }

  function shouldCheckForNewVersion() {
    let lastVersionCheckedAt = localStorage.getItem("lastVersionCheckedAt");
    if (lastVersionCheckedAt == null) {
      return true;
    }

    if (
      Date.now() - Number(lastVersionCheckedAt) >
      VERSION_CHECK_WITH_SERVER_AFTER
    ) {
      return true;
    }

    return false;
  }

  return {
    ensureVersionMatchWithServerLoop,
  };
};

export default VersionService;



// WEBPACK FOOTER //
// ./client/app/common/services/version.service.js